// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"d40bd21a","429":"bf154ebd","466":"b25a2161","478":"ead51957","787":"f1bccd6c"}[chunkId] + ".chunk.js";
};